import React, { Fragment, useState } from "react";
import SegmentList from "./components/SegmentList";
import FlightDatesRangeInput from "../../../Pages/Home/Components/FlightDatesRangeInput";
import { useLocation, useNavigate } from "react-router-dom";
import { flightSearchList } from "../../../utils/flightSearchList";
import {
  TRIP_TYPE_ONE_WAY,
  TRIP_TYPE_ROUND_TRIP,
} from "../../../common/constants";
import moment from "moment";
import { NDCExchangeReq } from "../NDCRequest/NDCRequest";
import ExchangeSideBar from "./components/ExchangeSideBar";
import { ExchangeNDCOrder } from "../Services/NDCApi";
import { toast } from "react-toastify";
import Loading from "../../Loading";
import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";

const flightClass = [
  {
    name: "Economy",
    href: "##",
  },
  {
    name: "Business",
    href: "##",
  },
];

const NDCExchangeSearch = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  let { ticketData, booking } = location.state;

  const flightInfo = booking?.flight;

  const {
    Passengers: { Passenger } = {},
    DataLists: { FlightList, ServiceList } = {},
    Payment: { Payment } = {},
    Order,
  } = ticketData;

  const [dateRangeValue, setDateRangeValue] = useState({
    startDate: null,
    endDate: null,
  });

  const [selectedFlight, setSelectedFlight] = useState([]);

  const origin = flightInfo?.origin;
  const destination = flightInfo?.destination;

  function getFlightName(code) {
    if (!code) return;
    return UseFlightName(code);
  }

  function UseFlightName(code) {
    return flightSearchList(code)?.filter((flight) => {
      return flight?.code === code;
    })?.[0]?.name;
  }

  const Segments =
    Order[0]?.OrderItems?.OrderItem?.[0]?.FlightItem?.OriginDestination?.map(
      (flight, index) => {
        return flight?.Flight?.map((segment) => {
          return {
            id: index,
            SegmentKey: segment?.SegmentKey,
            From: segment?.Departure?.AirportCode.value,
            To: segment?.Arrival?.AirportCode.value,
            carrier: segment?.MarketingCarrier?.AirlineID?.value,
            ClassOfService: segment?.ClassOfService?.MarketingName?.value,
            FlightNumber: segment?.MarketingCarrier?.FlightNumber?.value,
            BookingClass: segment?.ClassOfService?.Code?.value,
            Departure: {
              date: segment?.Departure?.Date,
              time: segment?.Departure?.Time,
            },
            Arrival: {
              date: segment?.Arrival?.Date,
              time: segment?.Arrival?.Time,
            },
          };
        });
      }
    );

  const FlightListData = FlightList?.Flight.length
    ? FlightList?.Flight?.map((flight) => {
        return flight?.SegmentReferences?.value;
      })
    : Segments?.map((segment) => {
        return segment?.map((flight) => {
          return flight?.SegmentKey;
        });
      });

  let OD =
    selectedFlight?.length > 0 &&
    selectedFlight?.map((flight, i) => {
      return {
        From: flight?.[0]?.From,
        To: flight?.at(-1)?.To,
        Id: flight?.[i]?.id,
      };
    });

  OD = OD.length > 0 && OD?.sort((a, b) => a.Id - b.Id);

  const handleClick = async (e) => {
    if (!OD) {
      toast.error("Please select a flight");
      return;
    }
    const originDest =
      OD?.length > 1
        ? [
            {
              originStationCode: OD?.[0]?.From,
              destStationCode: OD?.[0]?.To,
              depDate: moment(dateRangeValue.startDate).format("YYYY-MM-DD"),
              cabinPreferences: [flightClassState === "Economy" ? "Y" : "C"],
            },
            {
              originStationCode: OD?.[1]?.From,
              destStationCode: OD?.[1]?.To,
              depDate: moment(dateRangeValue.endDate).format("YYYY-MM-DD"),
              cabinPreferences: [flightClassState === "Economy" ? "Y" : "C"],
            },
          ]
        : [
            {
              originStationCode: OD?.[0]?.From,
              destStationCode: OD?.at(-1)?.To,
              depDate: moment(dateRangeValue.startDate).format("YYYY-MM-DD"),
              cabinPreferences: [flightClassState === "Economy" ? "Y" : "C"],
            },
          ];

    const flatFlight = selectedFlight.flat();
    const flatRefs = FlightListData.flat();

    const selectedRefs = flatFlight.map((flight) => {
      return flight.SegmentKey;
    });

    const retain = flatRefs.filter((ref) => {
      return !selectedRefs.includes(ref);
    });

    const matchingServices =
      ServiceList?.Service?.filter((service) =>
        service?.Associations?.some((association) =>
          association?.Flight?.originDestinationReferencesOrSegmentReferences?.some(
            (ref) => retain.includes(ref)
          )
        )
      ) ?? [];

    const serviceKeys = new Set(
      matchingServices.map((service) => service.ObjectKey)
    );

    const serviceReferences =
      Order?.[0]?.OrderItems?.OrderItem?.flatMap(
        (item) => item?.Associations?.IncludedService?.ServiceReferences
      ) ?? [];

    const retainServices = serviceReferences.filter((ref) =>
      serviceKeys.has(ref)
    );

    const data = {
      carrier: flightInfo?.carrier,
      PNR: flightInfo?.providerPnr,
      originDestCriteria: originDest,
      retain: retainServices,
      orderItems: Order?.[0]?.OrderItems?.OrderItem,
      // orderItems: Order?.[0]?.OrderItems?.OrderItem?.map((item) => {
      //   return {
      //     orderItemRefId: item?.OrderItemID?.value,
      //     retainServiceRefIds:
      //       item?.Associations?.IncludedService?.ServiceReferences.filter(
      //         (ref) => serviceKeys.has(ref)
      //       ),
      //   };
      // }),
    };

    const req = NDCExchangeReq(data);

    if (req) {
      const res = await ExchangeNDCOrder(req, flightInfo.carrier, setLoading);

      if (res?.Errors?.Error || res?.error) {
        toast.error(
          `Error in exchange reshop
          ${res?.Errors?.Error || res?.error?.code}`
        );
        return;
      }

      navigate(`/ndc-exchange-list/${flightInfo?.providerPnr}`, {
        state: {
          exchangeReshop: res?.response,
          ticketData: {
            Passenger,
            flatSegment,
          },
          booking,
          retain: retainServices,
          orderItems: Order?.[0]?.OrderItems?.OrderItem,
        },
      });
    }
  };

  const flatSegment = Segments?.flat();

  const [flightClassState, setFlightClassState] = useState("Economy");

  const renderSelectClass = () => {
    return (
      <div className="">
        <Popover className="relative">
          {({ open, close }) => (
            <>
              <Popover.Button
                className={`
         ${open ? "":""}
          px-4 py-1.5 rounded-md inline-flex items-center font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 text-xs`}
                onClick={() => document.querySelector("html")?.click()}
              >
                <span className="text-black">{`${flightClassState}`}</span>
                <ChevronDownIcon
                  className={`${
                    open ? "":"text-opacity-70 "}"w-4 h-4 transition duration-150 ease-in-out ml-2 group-hover:text-opacity-80"`}
                  aria-hidden="true"
                />
              </Popover.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute z-10 w-screen max-w-[200px] sm:max-w-[220px] px-4 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0 ">
                  <div className="overflow-hidden rounded-2xl ring-1 shadow-lg ring-black/5 dark:ring-white/10">
                    <div className="grid relative gap-8 p-7 bg-white dark:bg-neutral-800">
                      {flightClass.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          onClick={(e) => {
                            e.preventDefault();
                            setFlightClassState(item.name);
                            close();
                          }}
                          className="flex items-center p-2 -m-3 rounded-lg transition duration-150 ease-in-out hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        >
                          <p className="text-sm font-medium">{item.name}</p>
                        </a>
                      ))}
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      </div>
    );
  };

  if (loading) return <Loading />;

  return (
    <div className="mx-12">
      <h1 className="mx-5 my-8 w-1/2 text-2xl font-semibold text-gray-800">
        NDC Exchange Search
      </h1>
      <div className="flex flex-row-reverse justify-between">
        <div className="flex flex-col items-center mx-2 w-full">
          <SegmentList
            segments={Segments}
            selectedFlight={selectedFlight}
            setSelectedFlight={setSelectedFlight}
          />

          <div className="z-10 mx-auto mb-10 w-full max-w-5xl bg-white rounded-xl shadow-2xl border-1 border-slate-400">
            <div className="[ nc-hero-field-padding ] py-3 flex flex-row flex-wrap border-b border-neutral-100">
              <div className="my-1 mr-2 rounded-full border sm:mr-4 border-neutral-300">
                {renderSelectClass()}
              </div>
            </div>
            <form className="opacity-[0.96] w-full mt-6 rounded-xl xl:rounded-xl shadow-2xl bg-white z-10">
              <div className="flex flex-1 rounded-full">
                <div
                  className={`flex relative flex-1 flex-shrink-0 items-center space-x-3 text-left cursor-pointer [ nc-hero-field-padding--small ] focus:outline-none`}
                >
                  <div className="flex-1">
                    <input
                      className={`block p-0 w-full font-bold text-black truncate bg-transparent border-none focus:ring-0 focus:outline-none focus:placeholder-neutral-400 xl:text-base placeholder-neutral-800 dark:placeholder-neutral-200`}
                      value={getFlightName(OD?.[0]?.From || origin)}
                    />
                    <span className="block mt-0.5 text-sm text-neutral-400 font-light ">
                      <span className="line-clamp-1">
                        Flying from{" "}
                        <span className="font-bold">{OD?.[0]?.From}</span>
                      </span>
                    </span>
                  </div>
                </div>
                <div
                  className={`flex relative flex-1 flex-shrink-0 items-center space-x-3 text-left cursor-pointer [ nc-hero-field-padding--small ] focus:outline-none`}
                >
                  <div className="flex-1">
                    <input
                      className={`block p-0 w-full font-bold text-black truncate bg-transparent border-none focus:ring-0 focus:outline-none focus:placeholder-neutral-400 xl:text-base placeholder-neutral-800 dark:placeholder-neutral-200`}
                      value={getFlightName(OD?.[0]?.To || destination)}
                    />
                    <span className="block mt-0.5 text-sm text-neutral-400 font-light ">
                      <span className="line-clamp-1">
                        Flying to{" "}
                        <span className="font-bold">{OD?.[0]?.To}</span>
                      </span>
                    </span>
                  </div>
                </div>

                <FlightDatesRangeInput
                  exchange={true}
                  defaultDateValue={dateRangeValue}
                  tripType={
                    selectedFlight?.length > 1
                      ? TRIP_TYPE_ROUND_TRIP
                      : TRIP_TYPE_ONE_WAY
                  }
                  onChange={(data) => {
                    setDateRangeValue(data.stateDate);
                  }}
                  className="flex-1"
                />
              </div>
            </form>
          </div>
        </div>
        <ExchangeSideBar Passenger={Passenger} flatSegment={flatSegment} />
      </div>
      {dateRangeValue.startDate && (
        <div className="container flex justify-end p-4 mt-10 w-full">
          <button
            className="px-10 py-3 ml-2 text-base text-white rounded-lg bg-main"
            onClick={handleClick}
          >
            Continue
          </button>
        </div>
      )}
    </div>
  );
};

export default NDCExchangeSearch;
